// 处理 public\assets\js\config.js

const ApiUrl = window.sysConfig.ApiUrl
const ApiToken = window.sysConfig.ApiToken
const displayCartoon = window.sysConfig.displayCartoon
const reasoningModel = window.sysConfig.reasoningModel
const useConversationId = window.sysConfig.useConversationId
const WelcomeText = window.sysConfig.WelcomeText
const WelcomeTitle = window.sysConfig.WelcomeTitle
const VoiceConfig = window.sysConfig.VoiceConfig
const PageTitle = window.sysConfig.PageTitle
const LogoName = window.sysConfig.LogoName//ThHeader中的logoName
const inputTips = window.sysConfig.inputTips//输入框中的提示词
const hotList = window.sysConfig.hotList//热词列表
const fontSize = window.sysConfig.fontSize
const ttsWsUrl = window.sysConfig.ttsWebSocketUrl
const enableTts = window.sysConfig.enableTts

export {
  ApiUrl,
  ApiToken,
  reasoningModel,
  useConversationId,
  WelcomeText,
  WelcomeTitle,
  VoiceConfig,
  PageTitle,
  LogoName,
  inputTips,
  hotList,
  fontSize,
  ttsWsUrl,
  enableTts,
  displayCartoon,
}

